import { Accordion } from '../../../../../../components/general/accordion';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import { Grid } from '@mui/material';
import FieldText from '../../../../../../components/general/fields/fieldText';
import { PqrClosingProps } from '../props';
import { usePqrSample } from './hook';

export const PqrSample = ({ closing }: PqrClosingProps) => {
    const { formik } = usePqrSample(closing);

    return (
        <Accordion
            title="MUESTRA"
            icon={<FactCheckIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12}>
                    <FieldText
                        label="Observaciones de auditoría"
                        name="auditObservations"
                        rows={2}
                        value={formik.values.auditObservations}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
